module.exports = __webpack_public_path__ + "static/media/019-Kissen_ID_21.938d78fd.mp3";